module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "lavContainer",
    style: (_vm.style)
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07223bf5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/lottie.vue
// module id = 14
// module chunks = 0